import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SharedDataService } from 'src/app/services/shared-data.service';

@Component({
  selector: 'app-admin-admin',
  templateUrl: './admin-admin.component.html',
  styleUrl: './admin-admin.component.less',
  providers: [SharedDataService],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AdminAdminComponent {
  constructor() {}
}
